import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { HomeComponent } from './home.component'
import { HomeRoutingModule } from './home-routing.module'
import { SectionComponent } from 'src/app/components/section/section.component'
import { ContactFormComponent } from 'src/app/components/contact-form/contact-form.component'
import { HeaderComponent } from 'src/app/components/header/header.component'
import { FooterComponent } from 'src/app/components/footer/footer.component'
import { BrowseByCategoryComponent } from 'src/app/components/browse-by-category/browse-by-category.component'
import { BrowseByMakeComponent } from 'src/app/components/browse-by-make/browse-by-make.component'
import { HeroBannerComponent } from 'src/app/components/hero-banner/hero-banner.component'
import { AssetCarouselComponent } from 'src/app/components/asset-carousel/asset-carousel.component'
import { FeaturedCarouselComponent } from 'src/app/components/featured-carousel/featured-carousel.component'
import { LegalTermsComponent } from 'src/app/components/legal-terms/legal-terms.component'


@NgModule({
  declarations: [
    HomeComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    MatExpansionModule,
    MatSlideToggleModule,
    HeaderComponent,
    FooterComponent,
    SectionComponent,
    ContactFormComponent,
    BrowseByCategoryComponent,
    BrowseByMakeComponent,
    HeroBannerComponent,
    AssetCarouselComponent,
    FeaturedCarouselComponent,
    LegalTermsComponent,
  ],
  exports: [
    HomeComponent,
  ],
})
export class HomeModule {
  panelOpenState = false
}
